import React, { Component } from 'react';
import { connect } from 'react-redux';

import { getTagFilters } from 'selectors';

import ActiveTagFilter from './ActiveTagFilter';

class ActiveTagFilters extends Component {
  renderTagFilter = (tag, index) => {
    return (
      <ActiveTagFilter
        tag={tag}
        key={index}
        onDismiss={this.props.removeTagFilter}
      />
    );
  };

  render() {
    return (
      <div className="ActiveTagFilters">
        {this.props.activeTagFilters.map(this.renderTagFilter)}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    activeTagFilters: getTagFilters(state),
  };
}

export default connect(mapStateToProps)(ActiveTagFilters);



// WEBPACK FOOTER //
// ./src/Components/Pages/Results/ActiveTagFilters/index.js